import palette from './palette';
import { textPrimary } from './color';

export default {
  h1: {
    color: palette.text.primary,
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: '35px',
    letterSpacing: '-0.24px',
    lineHeight: '40px',
  },
  h2: {
    color: palette.text.primary,
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: '29px',
    letterSpacing: '-0.24px',
    lineHeight: '32px',
  },
  h3: {
    color: palette.text.primary,
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: '24px',
    letterSpacing: '-0.06px',
    lineHeight: '28px',
  },
  h4: {
    color: textPrimary,
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: '20px',
    letterSpacing: '-0.06px',
    lineHeight: '24px',
  },
  h5: {
    color: textPrimary,
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '20px',
  },
  h6: {
    color: palette.text.primary,
    fontWeight: 600,
    fontFamily: 'Poppins',
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '20px',
  },
  subtitle1: {
    fontFamily: 'Poppins',
    fontWeight: 400,
    color: palette.text.primary,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '25px',
  },
  subtitle2: {
    color: palette.text.secondary,
    fontFamily: 'Poppins',
    fontWeight: 400,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '21px',
  },
  body1: {
    color: textPrimary,
    fontFamily: 'Poppins',
    fontWeight: 300,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '20px',
  },
  body2: {
    color: palette.text.secondary,
    fontFamily: 'Poppins',
    fontWeight: 300,
    fontSize: '12px',
    letterSpacing: '-0.04px',
    lineHeight: '20px',
  },
  button: {
    fontFamily: 'Poppins',
    fontWeight: 600,
    color: palette.text.primary,
    fontSize: '14px',
  },
  caption: {
    color: palette.text.secondary,
    fontSize: '11px',
    fontFamily: 'Poppins',
    letterSpacing: '0.33px',
    lineHeight: '13px',
  },
  overline: {
    color: palette.text.secondary,
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: 'Poppins',
    letterSpacing: '0.33px',
    lineHeight: '13px',
    textTransform: 'uppercase',
  },
  primary: {
    color: textPrimary,
  },
};
